import { Component, EventEmitter, forwardRef, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-smash-checkbox',
  templateUrl: './smash-checkbox.component.html',
  styleUrls: ['./smash-checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SmashCheckboxComponent),
    }
  ]
})
export class SmashCheckboxComponent implements ControlValueAccessor {

  _checked: boolean = false;

  onChange: any = () => { };
  onTouched: any = () => { };

  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  writeValue(checked: boolean): void {
    this._checked = checked;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set checked(val) {
    this._checked = !this._checked;
    this.onChange(val);
    this.onTouched();
    this.valueChange.emit(val);
  }

  get checked() {
    return this._checked;
  }
}
